export interface LinkGroup {
  title: string;
  links: { text: string; url: string }[];
}

export const PRODUCT_LINKS: LinkGroup = {
  title: 'Product',
  links: [
    { text: 'Features', url: '/product' },
    { text: 'Reviews', url: '/reviews' },
    { text: 'Plans and Pricing', url: '/pricing' },
  ],
};

export const MIGHTY_PRO_LINKS: LinkGroup = {
  title: 'Mighty Pro',
  links: [
    { text: 'Pro Features', url: '/pro' },
    { text: 'Implementation Services', url: '/pro/services' },
    { text: 'Migration Services', url: '/migration' },
    { text: 'Pro Case Studies', url: '/case-studies?plan=pro' },
    { text: 'Pro for Non-Profits', url: '/pro/non-profit' },
  ],
};

export const RESOURCES_LINKS: LinkGroup = {
  title: 'Resources',
  links: [
    { text: 'Podcast', url: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa' },
    { text: 'Masterclass', url: '/peoplemagic' },
    { text: 'Mighty Experts', url: '/experts-directory' },
    { text: 'Case Studies', url: '/case-studies' },
    { text: 'Setup Training', url: 'https://community.mightynetworks.com/spaces/12898937/content' },
    {
      text: 'New Feature Training',
      url: 'https://community.mightynetworks.com/spaces/12890096/search?term=%23FeatureUpdates&sort=created_at&sort_order=desc',
    },
    { text: 'Weekly Sessions', url: 'https://community.mightynetworks.com/events' },
    { text: 'Help Center', url: 'https://faq.mightynetworks.com/' },
    { text: 'Showcase', url: '/showcase' },
    { text: 'Partner Program', url: '/partner-program' },
    { text: 'Overview', url: '/resources' },
  ],
};

export const COMPANY_LINKS: LinkGroup = {
  title: 'Company',
  links: [
    { text: 'About', url: '/about' },
    { text: 'Careers', url: '/careers' },
    { text: 'Trust Center', url: 'https://trust.mightynetworks.com/' },
    { text: 'Terms of Service', url: '/terms-of-use' },
    { text: 'Privacy Policy', url: '/privacy-policy' },
    { text: 'Accessibility', url: '/accessibility' },
  ],
};

export const COMPARISON_LINKS: LinkGroup = {
  title: 'Comparison',
  links: [
    { text: 'Mighty vs. Circle', url: '/resources/circle-vs-mighty-networks' },
    { text: 'Mighty vs. Kajabi', url: '/resources/mighty-networks-vs-kajabi' },
    { text: 'Mighty vs. Skool', url: '/resources/mighty-networks-vs-skool' },
  ],
};
